// ColacionHeatmapChart.jsx
import React from 'react';
import { HeatmapChart } from '@carbon/charts-react';
import '@carbon/charts/styles.css';

const ColacionHeatmapChart = ({
  data = [],
  title = 'Colación promedio por día y turno',
  height = '400px',
}) => {
  // Carbon espera: { group, key, value }
  const chartData = data.map(d => ({
    group: d.turno_label,   // "Día" / "Noche"
    key: d.fecha,           // fecha
    value: d.value_h,       // horas promedio
  }));

  const options = {
    title,
    height,

    // 🌙 Tema oscuro → textos blancos automáticamente
    theme: 'g100',

    axes: {
      left: {
        mapsTo: 'group',
        title: 'Turno',
        scaleType: 'labels',
      },
      bottom: {
        mapsTo: 'key',
        title: 'Fecha',
        scaleType: 'labels',
      },
    },

    heatmap: {
      colorLegend: {
        title: 'Colación (horas)',
      },
    },

    legend: {
      enabled: true,
    },

    // 🎨 Escala de colores clara (mejor contraste en fondo oscuro)
    color: {
      scale: {
        0: '#d0e2ff',
        1: '#0f62fe',
      },
    },
  };

  return <HeatmapChart data={chartData} options={options} />;
};

export default ColacionHeatmapChart;